import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const AboutProject = () => {
  return (
    <Box id="about" sx={{ py: 6 }}>
      <Typography variant="h4" sx={{ fontWeight: 700 }} gutterBottom>
        About Us
      </Typography>
      <Typography variant="h6" color="text.secondary" paragraph>
        This project started at UNC Chapel Hill and brings together students from UNC,
        NC State, and MIT along with seasoned trade industry experts. We blend
        academic rigor with field experience to deliver practical outcomes for
        contractors, service businesses, and specialty trades.
      </Typography>
    </Box>
  );
};

export default AboutProject;


